import {
  ACTIVE_PROGRESS,
  DISABLE_PROGRESS,
} from "redux/ActionTypes/ProgressActionTypes";

export const activeProgress = () => {
  return {
    type: ACTIVE_PROGRESS,
  };
};

export const disableProgress = () => {
  return {
    type: DISABLE_PROGRESS,
  };
};
